export default class BlockerButton {
  static create(type, text, onclick, tagOptions = {}){
    let element = document.createElement("div");
    element.className = `vjs-player-error__button vjs-player-error__${type}`;
    element.innerHTML = `<a class="vjs-player-error__${type}-link vjs-player-error__link">${text}</a>`;
    element.firstChild.onclick = onclick;

    if(tagOptions.href) element.firstChild.href = tagOptions.href;

    return element;
  }

  static createRevamp(type, text, onclick, tagOptions = {}, additionalClass){
    let element = document.createElement("div");
    element.className = `vjs-player-error__button-revamp vjs-player-error__${type}`;
    element.innerHTML = `<a class="vjs-player-error__${type}-link vjs-player-error__link-revamp ${additionalClass}">${text}</a>`;
    element.firstChild.onclick = onclick;

    if(tagOptions.href) element.firstChild.href = tagOptions.href;

    return element;
  }

   static createButtonReportWithLabel(type, label, text, onclick, tagOptions = {}){
    let element = document.createElement("span");
    element.className = `vjs-generic-error-text-label__${type}`;
    element.innerHTML = `${label} <a class="vjs-player-error__${type}-link">${text}</a>`;
    element.firstChild.nextSibling.onclick = onclick;

    if(tagOptions.href) element.firstChild.href = tagOptions.href;

    return element;
  }
}